// extracted by mini-css-extract-plugin
export default {"title":"OrderDetails_title__3lc3j"};